import { render, staticRenderFns } from "./exercises-result.vue?vue&type=template&id=57eaf81c"
import script from "./exercises-result.vue?vue&type=script&lang=js"
export * from "./exercises-result.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports